module.exports = __webpack_public_path__ + "static/media/icon_avaliacao.181592bb.svg";